import { TableRow, TableCell, IconButton, Typography, Collapse, Theme } from '@mui/material';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Amount } from 'lib/Amount/Amount';
import { calculateCompletion } from 'utils/calculateCompletion';
import PercentageDisplay from 'lib/PercentageDisplay';
import { calcPrincipalSum } from 'screens/Clients/utils/calculateLoanParts';
import TableCollapseArea from './LoanPartDetails';
import { LoanPartRowProps } from 'types/Client';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { LoanPartsProgress } from 'screens/Clients/components/BorderLinearProgress';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      cursor: 'pointer',
    },
    opened: {
      'backgroundColor': '#F7F4FC',
      '&:hover td.MuiTableCell-root': {
        backgroundColor: '#F7F4FC',
      },
      '& td.MuiTableCell-root': {
        borderBottom: '0px',
      },
    },
  })
);

function LoanPartRow({ loanPart, translationsRoot }: LoanPartRowProps) {
  const [open, setOpen] = useState(false);
  const principalSum = calcPrincipalSum(loanPart);
  const progress = calculateCompletion(principalSum, loanPart.residualDebt, 0) ?? 0;
  const { interestPeriod } = loanPart;
  const classes = useStyles();

  return (
    <>
      <TableRow
        className={`${classes.row} ${open ? classes.opened : null}`}
        onClick={() => setOpen(!open)}
        hover
      >
        <TableCell align="left">
          <Typography sx={{ fontWeight: 'bold' }}>{loanPart.product}</Typography>
        </TableCell>
        <TableCell align="left">
          <Amount value={principalSum} />
        </TableCell>
        <TableCell align="left">
          <Amount value={loanPart.residualDebt} />
        </TableCell>
        <TableCell align="left">
          <PercentageDisplay value={interestPeriod?.effectiveInterestRate} emptyValue="-" />
        </TableCell>
        <TableCell align="left">
          <LoanPartsProgress variant="determinate" value={progress} />
        </TableCell>
        <TableCell align="left">
          <IconButton aria-label="expand row">{open ? <RemoveIcon /> : <AddIcon />}</IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          colSpan={6}
          padding="none"
          style={{ backgroundColor: '#F7F4FC', border: 'none' }}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableCollapseArea loanPart={loanPart} translationsRoot={translationsRoot} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
export default LoanPartRow;
